import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  OverlayTrigger,
  Tooltip,
  InputGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./sellInSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  formatterStatus,
  checkEmptyFields,
  paramsMasterAll,
  useForceUpdate,
  formatCurrency,
  setOptionsMaster,
  formatQuantity,
  paramsStatus,
  formatQuantityDecimal,
  formatCurrencyNo,
  paramsStatusSellIn,
  defaultDate,
  setOptionsMaster2,
  getSettingValue,
  formatQuantityDecimalFix,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import {
  headerSortingClasses,
  sortCaret,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import {
  fetchProduct,
  fetchTemplate,
  selectLoadingTemplate,
  selectProduct,
} from "../product/productSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { fetchCompany, selectDataCompany } from "../company/companySlice";
import InputNumber from "../../utility/InputNumber";
import cellEditFactory from "react-bootstrap-table2-editor";
import SVG from "react-inlinesvg";
import { fetchParam, selectDataParam } from "../param/paramSlice";
import { Hidden, setRef } from "@material-ui/core";
import CurrencyInput from "react-currency-input-field";
import InputCurrency from "../../utility/InputCurrency";
import AsyncSelect from "react-select/async";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import debounce from "lodash/debounce";
import { selectSetting } from "../setting/settingSlice";

export const SellInCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const loading2 = useSelector(selectLoadingTemplate);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataProduct = useSelector(selectProduct);
  const dataParam = useSelector(selectDataParam);
  const dataCustomer = useSelector(selectCustomer);
  const { id } = useParams();
  const ref = useRef();
  const { SearchBar } = Search;
  const forceUpdate = useForceUpdate();
  const dataSetting = useSelector(selectSetting);

  const ALLOW_DISC = getSettingValue(dataSetting, "ALLOW_DISCOUNT_INPUT_WEB");
  const ALLOW_PRICE = getSettingValue(
    dataSetting,
    "ALLOW_ORDER_PRICE_INPUT_WEB"
  );

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [customer, setCustomer] = useState("");
  const [date, setDate] = useState(defaultDate);
  const [term, setTerm] = useState("");
  const [remarks, setRemarks] = useState("");
  const [reference, setReference] = useState("");
  const [tax, setTax] = useState(null);
  const [taxAmount, setTaxAmount] = useState(0);
  const [disc, setDisc] = useState(0);
  const [discTemp, setDiscTemp] = useState(0);
  const [discPersen, setDiscPersen] = useState(0);
  const [discPersenTemp, setDiscPersenTemp] = useState(0);
  const [total, setTotal] = useState(0);
  const [netTotal, setNetTotal] = useState(0);
  const [status, setStatus] = useState("DRAFT");
  const [statusTemp, setStatusTemp] = useState("");

  const [tableData, setTableData] = useState([]);

  const [tableProduct, setTableProduct] = useState([]);
  const [show, setShow] = useState(false);
  const [showBonus, setShowBonus] = useState(false);
  const [dataBonus, setDataBonus] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);

  const [optionsTax, setOptionsTax] = useState([]);
  const [optionsCust, setOptionsCust] = useState([]);

  const [hasInitialized, setHasInitialized] = useState(false);

  const prevSumRef = useRef(0);

  const paramsId = {
    sell_in_header_id: id,
  };


  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
      // await dispatch(
      //   fetchProduct({ ...paramsMasterAll, get_alternate_uoms: true })
      // );
      await dispatch(fetchCustomer({ pageNo: 1, pageSize: 20 }));
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "VAT",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setDate(dataId?.sell_in_date);
      setCode(dataId?.sell_in_no);
      setTax(dataId?.tax);
      setCustomer(dataId.customer_id);
      setTaxAmount(dataId?.tax_amount);
      setTotal(dataId?.total_amount);
      setNetTotal(parseFloat(dataId?.net_total));
      setStatus(dataId?.status);
      setStatusTemp(dataId?.status === "CONFIRM" ? true : false);
      setRemarks(dataId?.remarks);
      setReference(dataId?.reference_no);
      setDisc(parseFloat(dataId?.discount_amount));
      setDiscPersen(parseFloat((parseFloat(dataId?.discount) || 0).toFixed(2)));
      setDiscPersenTemp(parseFloat(dataId?.discount));

      const initData = dataId?.details?.map((item, index) => {
        const discountNum = parseFloat(item.discount);
        return {
          ...item,
          no: index + 1,
          discount: isNaN(discountNum) ? "0.000" : discountNum.toFixed(2),
          discount_temp: discountNum,
        };
      });

      setTableData(initData);
    }
  }, [dataId]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsTax, "param_code", "param_value");
    }
  }, [dataParam]);

  useEffect(() => {
    if (!hasInitialized && dataCustomer.length > 0) {
      setOptionsMaster2(dataCustomer, setOptionsCust, "customer_id", [
        "customer_code",
        "customer_store_name",
      ]);
      setHasInitialized(true);
    }
  }, [dataCustomer, hasInitialized]);

  // useEffect(() => {
  //   tableData.forEach((row, index) => {
  //     if (row.quantity > 0) {
  //       handleQty(null, row, index, null);
  //       console.log("jalan asdsadasd");

  //       // force update field utama dari calculation_details
  //       const calc = row.calculation_details;
  //       if (calc) {
  //         row.discount = calc.reg_discount_percent;
  //         row.discount_temp = calc.reg_discount_percent;
  //         row.discount_amount = calc.total_discount_amount;
  //         row.discount_amount_temp = calc.total_discount_amount;
  //         row.unit_price_disc = calc.unit_price_after_discount;
  //         row.line_total = calc.line_total;
  //       }
  //     }
  //   });

  //   // jika kamu pakai setData agar re-render
  //   setTableData([...tableData]);
  // }, []);

  useEffect(() => {
    if (dataProduct.length > 0) {
      const initData = dataProduct.map((item, index) => ({
        ...item,
        no: index + 1,
        quantity: 0,
        unit_price: item.price,
        unit_price_temp: item.price,
        unit_price_disc: 0,
        total_price: 0,
        discount: 0,
        discount_temp: 0,
        discount_amount: 0,
        discount_amount_temp: 0,
        line_total: 0,
        bonus_item: [],
      }));
      setTableProduct(initData);
    }
  }, [dataProduct]);

  useEffect(() => {
    handleSumGross();
    console.log("useeffect sumgross");
  }, [tax, disc, tableData]);

  const handleSave = async (status) => {
    const fields = [{ value: tax, message: "input TAX", valid: true }];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    const validateData = (data) => {
      const quantityErrors = [];
      const priceErrors = [];

      if (data.length === 0) {
        return "Details cannot be empty."; // Menambahkan validasi untuk array kosong
      }

      data.forEach((item) => {
        if (item.quantity === 0) {
          quantityErrors.push(item.product_name);
        }
        if (item.unit_price === 0) {
          priceErrors.push(item.product_name);
        }
      });

      let errorMessage = "";

      if (quantityErrors.length > 0) {
        errorMessage += `Quantity cannot be 0 for product: ${quantityErrors.join(
          ", "
        )}.\n`;
      }

      if (priceErrors.length > 0) {
        errorMessage += `Unit price cannot be 0 for product: ${priceErrors.join(
          ", "
        )}.`;
      }

      return errorMessage;
    };

    const validationResult = validateData(tableData);

    if (validationResult) {
      return showDialog(validationResult);
    }

    const params = {
      sell_in_header_id: id,
      user_id: user.user_id,
      sell_in_date: date,
      tax: tax,
      customer_id: customer,
      tax_amount: taxAmount,
      discount_amount: parseFloat(disc),
      discount: discPersenTemp,
      remarks: remarks,
      details: tableData.map((item) => {
        return {
          ...item,
          discount: item.discount_temp,
          discount_amount: item.discount_amount_temp,
          unit_price: item.unit_price_temp,
        };
      }),
      reference_no: reference,
      status: status,
    };
    console.log(params, "params");
    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    const getBestDiscount = (discounts, qty) => {
      const applicable = discounts.filter((disc) => {
        const minQty = parseFloat(disc.min_quantity || 0);
        return qty >= minQty;
      });

      if (applicable.length === 0) return null;

      return applicable.reduce((prev, curr) => {
        return parseFloat(curr.min_quantity || 0) >
          parseFloat(prev.min_quantity || 0)
          ? curr
          : prev;
      });
    };

    const calculateRegularDiscount = (discount, unitPrice) => {
      if (!discount) return { percent: 0, amount: 0 };

      const percentage = parseFloat(discount.percentage || 0);
      const fixedAmount = parseFloat(discount.amount || 0);

      if (percentage > 0) {
        const amount = (unitPrice * percentage) / 100;
        return { percent: percentage, amount };
      }

      if (fixedAmount > 0) {
        return { percent: 0, amount: fixedAmount };
      }

      return { percent: 0, amount: 0 };
    };

    const calculateSpecialDiscount = (
      spec,
      unitPrice,
      regularDiscountAmount
    ) => {
      if (!spec) return { total: 0, levels: [] };

      let total = 0;
      let base =
        spec.calculation_type === "AFTER"
          ? unitPrice - regularDiscountAmount
          : unitPrice;

      const levels = [];

      for (let i = 1; i <= 3; i++) {
        const perc = parseFloat(spec[`percentage_level_${i}`] || 0);
        const amt = parseFloat(spec[`amount_level_${i}`] || 0);

        let discount = 0;
        if (perc > 0) {
          discount = (base * perc) / 100;
          base -= discount;
        } else if (amt > 0) {
          discount = amt;
          base -= amt;
        }

        levels.push({
          level: i,
          percentage: perc,
          amount: amt,
          applied_discount: discount,
        });

        total += discount;
      }

      return { total, levels };
    };

    const getBonusItems = (spec, qty) => {
      const bonuses = [];

      if (!spec || !Array.isArray(spec.special_discount_bonus_items))
        return bonuses;

      const minQty = parseFloat(spec.min_quantity || 1);

      for (const bonus of spec.special_discount_bonus_items) {
        if (!bonus.is_active) continue;

        const bonusQty = parseFloat(bonus.bonus_quantity || 0);
        let applied = bonusQty;

        if (bonus.is_apply_multiples) {
          applied = bonusQty * Math.floor(qty / minQty);
        }

        if (applied > 0) {
          bonuses.push({ ...bonus, applied_bonus_quantity: applied });
        }
      }

      return bonuses;
    };

    // === MULAI PERHITUNGAN ===
    const qty = parseFloat(row.quantity) || 0;
    if (qty < 0) {
      row.quantity = 0;
      return;
    } else {
      row.quantity = qty;
    }

    const unitPrice = parseFloat(row.unit_price || 0);

    // === REGULAR DISCOUNT ===
    const regDisc = getBestDiscount(row.regular_discounts || [], qty);
    const { percent: regPercent, amount: regAmount } = calculateRegularDiscount(
      regDisc,
      unitPrice
    );

    // === SPECIAL DISCOUNT ===
    const specialList = row.special_discounts?.special_discount_products || [];
    const activeSpecials = specialList.filter((s) => {
      const minQty = parseFloat(s.min_quantity || 0);
      return (
        s.is_active && s.product_code === row.product_code && qty >= minQty
      );
    });
    const selectedSpecial = getBestDiscount(activeSpecials, qty);
    const calculationType =
      selectedSpecial?.calculation_type?.toUpperCase() || "AFTER";
    const { total: specAmount, levels: specLevels } = calculateSpecialDiscount(
      selectedSpecial,
      unitPrice,
      regAmount
    );

    // === BONUS ITEM ===
    const bonusItems = getBonusItems(selectedSpecial, qty);

    // === FINAL CALCULATION ===
    const totalDiscount = regAmount + specAmount;
    const unitPriceAfterDisc = unitPrice - totalDiscount;
    const lineTotal = qty * unitPriceAfterDisc;

    // === ASSIGN TO ROW ===
    row.reg_discount = regPercent;
    row.reg_discount_amount = regAmount;
    row.spec_discount = specAmount;
    row.discount_amount = totalDiscount;
    row.discount_amount_temp = totalDiscount;
    row.unit_price_disc = unitPriceAfterDisc;
    row.line_total = lineTotal;
    row.bonus_item = bonusItems;

    row.calculation_details = {
      quantity: qty,
      unit_price: unitPrice,
      reg_discount_percent: regPercent,
      reg_discount_amount: regAmount,
      spec_discount_amount: specAmount,
      total_discount_amount: totalDiscount,
      unit_price_after_discount: unitPriceAfterDisc,
      line_total: lineTotal,
      special_discount_type: calculationType,
      bonus_items: bonusItems,
      special_discount_levels: specLevels, // ← perhitungan diskon level
    };

    console.log("Calculation Summary:", row.calculation_details);

    handleSumGross();
    forceUpdate();
  };

  console.log(tableData, "tabledata ASDASDSA");

  const inputQtyFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="text"
        className="input-qty"
        style={{ textAlign: "right" }} // Align text to the right
        value={parseFloat(row.quantity).toLocaleString("id-ID")}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
        onChange={(e) => {
          const rawValue = e.target.value.replace(/[^\d.-]/g, "");
          if (rawValue) {
            e.target.value = parseFloat(rawValue).toLocaleString("id-ID");
          }
        }}
      />
    );
  };

  const handlePrice = (e, row, rowIndex, formatExtraData) => {
    // Ensure quantity is not negative
    if (row.unit_price < 0) {
      row.unit_price = 0;
    } else if (row.unit_price === undefined) {
      row.unit_price = 0;
    }

    row.unit_price = parseFloat(row.unit_price);
    row.unit_price_temp = parseFloat(row.unit_price).toFixed(2);

    row.discount_amount = parseFloat(
      ((row.unit_price * row.discount) / 100).toFixed(2)
    );
    row.discount_amount_temp = (row.unit_price * row.discount) / 100;

    row.unit_price_disc = row.unit_price - row.discount_amount;
    row.line_total = row.quantity * (row.unit_price - row.discount_amount);

    // Force component re-render if necessary
    handleSumGross();
    forceUpdate();
  };

  const inputPriceFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="text" // Ganti dengan tipe "text" untuk mendukung pemisah ribuan
        className="input-currency"
        value={parseFloat(row.unit_price).toLocaleString("id-ID")} // Menampilkan angka dengan pemisah ribuan
        onBlur={handlePrice(e, row, rowIndex, formatExtraData)}
        onChange={(e) => {
          // Menghilangkan pemisah ribuan saat perubahan input
          const rawValue = e.target.value.replace(/[^\d.-]/g, ""); // Menghapus semua selain angka dan titik
          if (rawValue) {
            // Mengonversi kembali ke format angka
            e.target.value = parseFloat(rawValue).toLocaleString("id-ID");
          }
        }}
        style={{ textAlign: "right" }} // Align text to the right
      />
    );
  };

  const handleDiscount = (e, row, rowIndex, formatExtraData) => {
    // Ensure discount is not negative and does not exceed 100%
    if (row.discount < 0) {
      row.discount = 0;
    } else if (row.discount > 100) {
      row.discount = 100;
    } else if (row.discount === undefined) {
      row.discount = 0;
    }

    // Perhitungan diskon dasar
    row.discount_amount_temp = (row.unit_price * row.discount) / 100;
    row.discount_amount = row.discount_amount_temp.toFixed(2);

    row.unit_price_disc =
      row.unit_price - (row.unit_price * row.discount) / 100;
    row.line_total = row.quantity * row.unit_price_disc;

    // Re-render
    handleSumGross();
    forceUpdate();
  };

  const inputDiscountFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="text"
        className="input-qty"
        value={formatQuantityDecimalFix(row.discount)}
        onBlur={handleDiscount(e, row, rowIndex, formatExtraData)}
        onChange={(e) => {
          const rawValue = e.target.value.replace(/[^\d.-]/g, "");
          if (rawValue) {
            row.discount = parseFloat(rawValue); // Store raw value without formatting
            forceUpdate(); // Trigger re-render to reflect raw value
          }
        }}
        style={{ textAlign: "right" }} // Align text to the right
      />
    );
  };

  const handleDiscAmount = (e, row, rowIndex, formatExtraData) => {
    // Ensure quantity is not negative
    if (row.discount_amount < 0) {
      row.discount_amount = 0;
    } else if (row.discount_amount === undefined) {
      row.discount_amount = 0;
    }

    // Validate that discount_amount is not greater than unit_price
    if (row.discount_amount > row.unit_price) {
      row.discount_amount = row.unit_price;
    }

    // Check if total_price exists and is greater than 0 to avoid division by zero
    if (row.unit_price > 0) {
      // Calculate the discount as a percentage of unit_price
      row.discount_temp = (row.discount_amount / row.unit_price) * 100;
      row.discount = row.discount_temp;
    } else {
      row.discount = 0;
      row.discount_temp = 0;
    }

    // Ambil data diskon sistem (reguler + spesial)
    const calculation = row.calculation_details || {};
    const regDiscAmt = calculation.reg_discount_amount ?? 0;
    const specDiscAmt = calculation.spec_discount_amount ?? 0;
    const totalSystemDiscount = regDiscAmt + specDiscAmt;

    // Hitung manual diskon (berdasarkan input user)
    const manualDiscAmt = (row.unit_price * row.discount) / 100;
    const diffAmt = manualDiscAmt - totalSystemDiscount;

    if (Math.abs(manualDiscAmt - totalSystemDiscount) < 0.001) {
    } else {
      // Update ke calculation_details

      row.calculation_details = {
        ...calculation,
        reg_discount_percent: 0,
        reg_discount_amount: 0,
        spec_discount_amount: 0,
        total_discount_amount: manualDiscAmt,
        unit_price_after_discount: row.unit_price - manualDiscAmt,
        bonus_items: [],
        special_discount_levels: [],
      };
    }

    handleSumGross();

    forceUpdate();
  };

  const inputDiscAmountFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="text" // Ganti dengan tipe "text" untuk mendukung pemisah ribuan
        className="input-currency"
        value={formatQuantityDecimalFix(row.discount_amount)} // Menampilkan angka dengan pemisah ribuan
        onBlur={handleDiscAmount(e, row, rowIndex, formatExtraData)}
        onChange={(e) => {
          // Menghilangkan pemisah ribuan saat perubahan input
          const rawValue = e.target.value.replace(/[^\d.-]/g, ""); // Menghapus semua selain angka dan titik
          if (rawValue) {
            // Mengonversi kembali ke format angka
            e.target.value = parseFloat(rawValue).toLocaleString("id-ID");
          }
        }}
        style={{ textAlign: "right" }} // Align text to the right
      />
    );
  };

  // UOM Render
  const getValueUom = (value, options) => {
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);
    const uom = selected[0];

    formatExtraData[rowIndex].returnUom = e.value;

    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.alternate_uoms;
    let cell_uom = cell;

    const options_this = [{ value: "", label: "" }];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom_code,
        label: value.uom_description,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const actionFormatter = (e, row) => {
    return (
      <div>
        {(id === undefined || dataId?.status === "DRAFT") && (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
              onClick={() =>
                setTableData((prevProducts) =>
                  prevProducts
                    .filter(
                      (product) => product.product_code !== row.product_code
                    )
                    .map((product, index) => ({
                      ...product,
                      no: index + 1,
                    }))
                )
              }
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        )}

        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Detail</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => {
              setDataBonus({
                ...row.calculation_details,
                product_code: row.product_code,
                product_name: row.product_name,
              });
              setShowBonus(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "Action",
      dataField: "action",
      align: "center",
      formatter: actionFormatter,
      style: { minWidth: dataId?.status === "CONFIRM" ? "70px" : "120px" },
      editable: false,
      formatter: actionFormatter,
    },
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "65px" },
    },

    {
      text: "product",
      dataField: "product_code",
      editable: false,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <b>{row.product_code}</b>
            </span>
            <br />
            <span>{row.product_name}</span>
          </div>
        );
      },
    },
    {
      text: " name",
      dataField: "product_name",
      editable: false,
      style: { minWidth: "130px" },
      hidden: true,
    },
    {
      text: "uom",
      dataField: "uom_description",
      editable: false,
      style: { minWidth: "130px" },
      // formatter: renderUom,
      formatExtraData: tableData,
    },
    {
      text: "qty",
      dataField: "quantity",
      editable:
        id === undefined ? true : dataId?.status === "DRAFT" ? true : false,
      style: { minWidth: "80px" },
      formatter:
        id === undefined
          ? inputQtyFormatter
          : dataId?.status === "DRAFT"
          ? inputQtyFormatter
          : formatQuantity,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      align: "right",
    },
    {
      text: "unit price",
      dataField: "unit_price",
      editable:
        ALLOW_PRICE === "OFF"
          ? false
          : id === undefined || dataId?.status === "DRAFT",
      style: { minWidth: "180px" },
      formatter:
        ALLOW_PRICE === "OFF"
          ? formatCurrency
          : id === undefined || dataId?.status === "DRAFT"
          ? inputPriceFormatter
          : formatCurrency,

      editorRenderer: (editorProps, value) => {
        return <InputCurrency {...editorProps} value={value} />;
      },
      align: "right",
    },

    {
      text: "disc % ",
      dataField: "discount",
      editable:
        ALLOW_DISC === "OFF"
          ? false
          : id === undefined || dataId?.status === "DRAFT",
      style: { minWidth: "120px" },
      formatter:
        ALLOW_DISC === "OFF"
          ? formatQuantity
          : id === undefined || dataId?.status === "DRAFT"
          ? inputDiscountFormatter
          : formatQuantity,

      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      align: "right",
    },

    {
      text: "disc amount",
      dataField: "discount_amount",
      editable:
        ALLOW_DISC === "OFF"
          ? false
          : id === undefined || dataId?.status === "DRAFT",

      style: { minWidth: "180px" },
      formatter:
        ALLOW_DISC === "OFF"
          ? formatCurrency
          : id === undefined || dataId?.status === "DRAFT"
          ? inputDiscAmountFormatter
          : formatCurrency,
      editorRenderer: (editorProps, value) => {
        return <InputCurrency {...editorProps} value={value} />;
      },
      align: "right",
      formatExtraData: tableData,
    },
    {
      text: "final price",
      dataField: "unit_price_disc",
      editable: false,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "line total",
      dataField: "line_total",
      editable: false,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
  ];

  const columnsProduct = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "uom",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const onSelectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const filteredRows = rows.filter(
          (row) =>
            !tableData.some(
              (selectedRow) => selectedRow.product_code === row.product_code
            )
        );
        setSelectedRows([...selectedRows, ...filteredRows]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        if (
          tableData.filter((e) => e.product_code === row.product_code).length >
          0
        ) {
          showDialog("Already selected");
          return false;
        }
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
      return true;
    },
  };

  const handleClose = () => {
    setShow(false);
    setSelectedRows([]);
  };

  const handleSubmit = () => {
    const result = selectedRows.filter(
      (elem) =>
        !tableData.find(
          ({ product_code }) => elem.product_code === product_code
        )
    );
    setTableData((data) => [
      ...data,
      ...result.map((item, index) => ({
        ...item,
        no: data.length + index + 1,
      })),
    ]);
    setSelectedRows([]);
    handleClose();
  };

  const handleSumGross = () => {
    const dataAmount = tableData.map((e) => parseFloat(e.line_total) || 0);
    const sum =
      dataAmount.length > 0
        ? dataAmount.reduce((item, value) => item + value, 0)
        : 0;

    // Bandingkan jika sum berubah
    if (prevSumRef.current !== sum) {
      // Jika ya, hitung ulang disc dari persen
      const _discPersen = discPersen || 0;
      const _discount = (_discPersen / 100) * sum;
      setDisc(_discount); // Update diskon nominal
    }

    prevSumRef.current = sum;

    // Gunakan diskon yang sudah di-set
    const _discount = parseFloat(disc) || 0;
    const totalAfterDiscount = sum - _discount;

    const _vatCode = tax || 0;
    const totalPajak = (_vatCode / 100) * totalAfterDiscount;
    const grandTotal = totalAfterDiscount + totalPajak;

    setTotal(sum);
    setTaxAmount(totalPajak);
    setNetTotal(grandTotal);
  };

  const handleChangeTax = createChangeHandler(setTax);
  const handleChangeStatus = createChangeHandler(setStatus);

  const handleChangeCust = async (e) => {
    if (e === null) {
      e = undefined;
      setCustomer("");
    } else {
      setCustomer(e.value);
      await dispatch(
        fetchProduct({
          ...paramsMasterAll,
          get_alternate_uoms: true,
          customer_id: e.value,
        })
      );
    }
  };

  const handleScroll = async (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;

    if (scrollHeight - scrollTop === clientHeight) {
      const nextPage = page + 1;
      setPage(nextPage);

      try {
        const response = await dispatch(
          fetchCustomer({
            customer_code: searchTerm,
            pageNo: nextPage,
            pageSize: 20,
          })
        );

        const newData = response.payload.data.data.map((e) => ({
          value: e.customer_id,
          label: e.customer_code + "-" + e.customer_store_name,
        }));

        // Hilangkan duplikat berdasarkan customer_id
        setOptionsCust((prevOptions) => {
          const existingIds = new Set(prevOptions.map((item) => item.value));
          const filteredNewData = newData.filter(
            (item) => !existingIds.has(item.value)
          );
          return [...prevOptions, ...filteredNewData];
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  // Fungsi debounced untuk mendapatkan data dari API
  const fetchDataFromApi = debounce(async (inputValue) => {
    try {
      // Simulate fetching data from the server or another source
      const response = await dispatch(
        fetchCustomer({
          customer_code: inputValue,

          pageNo: 1,
          pageSize: 20,
        })
      );

      const data = response.payload.data.data.map((e) => ({
        value: e.customer_id,
        label: e.customer_code + "-" + e.customer_store_name,
      }));

      // Merge the new options with the existing options
      setOptionsCust(data);
      setPage(1); // Reset halaman ke 1 saat cari
    } catch (error) {
      // Handle errors, e.g., log or show an error message
      console.error("Error fetching data:", error);
    }
  }, 1000);

  // bonus

  const handleCloseBonus = () => {
    setShowBonus(false);
    setDataBonus(null);
  };

  return loading || loading2 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Sell In"
              : `View Sell In : ${dataId?.sell_in_no}`}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn  btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left mr-2"></i> Back
            </Button>
            {id === undefined && (
              <>
                <Button
                  className="btn  btn-outline-primary mr-3"
                  onClick={(e) => handleSave("DRAFT")}
                >
                  <i className="fa fa-save mr-2"></i> Draft
                </Button>
                <Button
                  className="btn  btn-danger"
                  onClick={(e) => handleSave("CONFIRM")}
                >
                  <i className="fa fa-check mr-2"></i> Save
                </Button>
              </>
            )}
            {dataId?.status === "DRAFT" && (
              <>
                <Button
                  className="btn  btn-outline-primary mr-3"
                  onClick={(e) => handleSave("DRAFT")}
                >
                  <i className="fa fa-save mr-2"></i> Draft
                </Button>
                <Button
                  className="btn btn-danger"
                  onClick={(e) => handleSave("CONFIRM")}
                >
                  <i className="fa fa-check mr-2"></i> Save
                </Button>
              </>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Row>
              {/* Company */}
              <Col sm={3}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Customer</b>
                  </Form.Label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsCust}
                    value={getValueStatus(customer, optionsCust)}
                    onChange={handleChangeCust}
                    onMenuScrollToBottom={handleScroll}
                    onInputChange={(inputValue, { action }) => {
                      if (action === "input-change") {
                        setSearchTerm(inputValue); // simpan ke state
                        fetchDataFromApi(inputValue);
                      }
                    }}
                    isDisabled={dataId?.status === "CONFIRM"}
                  />
                </Form.Group>
              </Col>

              {/* Reference */}
              <Col sm={3}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Reference</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={reference}
                    onChange={(e) => setReference(e.target.value)}
                    disabled={
                      id === undefined || dataId?.status === "DRAFT"
                        ? false
                        : true
                    }
                  />
                </Form.Group>
              </Col>

              {/* TAX */}
              <Col sm={3}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>
                      TAX <span className="color-red">*</span>
                    </b>
                  </Form.Label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsTax}
                    value={getValueStatus(tax, optionsTax)}
                    placeholder="Select ..."
                    onChange={handleChangeTax}
                    isClearable
                    isDisabled={
                      id === undefined || dataId?.status === "DRAFT"
                        ? false
                        : true
                    }
                  />
                </Form.Group>
              </Col>

              <Col sm={3}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Doc Date</b>
                  </Form.Label>
                  <Form.Control type="date" value={date} disabled />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </CardBody>

        {/* <hr/> */}

        <CardBody>
          <ToolkitProvider
            keyField="no"
            data={tableData}
            columns={columns}
            search
          >
            {(props) => (
              <>
                {/* Header: Title + Add Button + Search */}
                <Row className="mb-3">
                  <Col>
                    <div className="float-right">
                      {id === undefined || dataId?.status === "DRAFT" ? (
                        <Button
                          className="btn btn-sm btn-outline-danger mr-3"
                          onClick={() => setShow(true)}
                          disabled={!customer}
                        >
                          <i className="fa fa-plus"></i> Add Product
                        </Button>
                      ) : null}

                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search..."
                      />
                    </div>
                  </Col>
                </Row>

                {/* Table Container */}
                <div
                  style={{
                    overflowY: "auto",
                    maxHeight: "400px",
                    border: "1px solid #dee2e6",
                    borderRadius: "0.5rem",
                    padding: "1rem",
                    backgroundColor: "#ffffff",
                  }}
                  className="mb-4"
                >
                  <BootstrapTable
                    striped
                    noDataIndication="Data Not Found"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered
                    {...props.baseProps}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                    })}
                  />
                </div>
              </>
            )}
          </ToolkitProvider>

          {/* Remarks + Summary Form */}
          <Form className="mt-4">
            <Row>
              {/* Remarks Section */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Remarks</b>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    disabled={
                      id === undefined
                        ? false
                        : dataId?.status === "DRAFT"
                        ? false
                        : true
                    }
                  />
                </Form.Group>
              </Col>

              {/* Summary Section */}
              <Col md={6}>
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "0.75rem",
                    padding: "1.5rem",
                    backgroundColor: "#fdfdfd",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                >
                  {/* Total */}
                  <Form.Group as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>
                      <strong>Total</strong>
                    </Form.Label>
                    <Col sm={8}>
                      <InputGroup>
                        <InputGroup.Text>Rp</InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={formatQuantityDecimal(total)}
                          className="text-right fw-bold bg-light"
                          disabled
                          readOnly
                        />
                      </InputGroup>
                    </Col>
                  </Form.Group>

                  {/* Discount */}
                  <Form.Group as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>
                      <strong>Discount</strong>
                    </Form.Label>
                    <Col sm={3}>
                      <InputGroup>
                        <InputGroup.Text>%</InputGroup.Text>
                        <Form.Control
                          type="number"
                          value={discPersen}
                          className="text-right"
                          onChange={(e) => {
                            let persenValue = parseFloat(e.target.value) || 0;
                            persenValue = Math.max(
                              0,
                              Math.min(persenValue, 100)
                            );
                            const parsedTotal = parseFloat(total) || 0;
                            const calculatedDisc =
                              (persenValue / 100) * parsedTotal;

                            setDisc(calculatedDisc);
                            setDiscPersen(persenValue);
                          }}
                          disabled={
                            ALLOW_DISC === "OFF" ||
                            (id !== undefined && dataId?.status !== "DRAFT")
                          }
                        />
                      </InputGroup>
                    </Col>
                    <Col sm={5}>
                      <InputGroup>
                        <InputGroup.Text>Rp</InputGroup.Text>
                        <CurrencyInput
                          id="discount-input"
                          className="form-control text-right"
                          name="Discount"
                          decimalsLimit={2}
                          onValueChange={(value) => {
                            if (parseFloat(value) > parseFloat(total)) {
                              setDisc(total);
                              setDiscPersen(100);
                            } else if (
                              parseFloat(value) < 0 ||
                              value === undefined
                            ) {
                              setDisc(0);
                              setDiscPersen(0);
                            } else {
                              setDisc(value);
                              const percentage =
                                (parseFloat(value) / parseFloat(total)) * 100;
                              setDiscPersen(percentage.toFixed(2));
                              setDiscPersenTemp(percentage);
                            }
                          }}
                          groupSeparator="."
                          decimalSeparator=","
                          value={disc}
                          disabled={
                            ALLOW_DISC === "OFF" ||
                            (id !== undefined && dataId?.status !== "DRAFT")
                          }
                        />
                      </InputGroup>
                    </Col>
                  </Form.Group>

                  {/* Tax */}
                  <Form.Group as={Row} className="mb-3 align-items-center">
                    <Form.Label column sm={4}>
                      <strong>Tax</strong>
                    </Form.Label>
                    <Col sm={8}>
                      <InputGroup>
                        <InputGroup.Text>Rp</InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={formatQuantityDecimal(taxAmount)}
                          className="text-right fw-bold bg-light"
                          disabled
                          readOnly
                        />
                      </InputGroup>
                    </Col>
                  </Form.Group>

                  {/* Grand Total */}
                  <Form.Group
                    as={Row}
                    className="align-items-center border-top pt-3 mt-3"
                  >
                    <Form.Label column sm={4}>
                      <strong>Grand Total</strong>
                    </Form.Label>
                    <Col sm={8}>
                      <InputGroup>
                        <InputGroup.Text>Rp</InputGroup.Text>
                        <Form.Control
                          type="text"
                          value={formatQuantityDecimal(netTotal)}
                          className="text-right fw-bold bg-light"
                          disabled
                          readOnly
                        />
                      </InputGroup>
                    </Col>
                  </Form.Group>
                </div>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>

      <Modal
        show={show}
        size="lg"
        dialogClassName="modal-70"
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body p-4">
            <ToolkitProvider
              keyField="no"
              data={tableProduct}
              columns={columnsProduct}
              search
            >
              {(props) => (
                <>
                  <Row className="mb-3">
                    <Col md={6}>
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search product by code or name.."
                        className="form-control"
                      />
                    </Col>
                  </Row>
                  <div style={{ overflowY: "auto", maxHeight: "400px" }}>
                    <BootstrapTable
                      striped
                      hover
                      condensed
                      noDataIndication="Data Not Found"
                      classes="table table-head-custom table-vertical-center table-hover cursor-pointer"
                      bootstrap4
                      bordered
                      {...props.baseProps}
                      selectRow={onSelectRow}
                    />
                  </div>
                </>
              )}
            </ToolkitProvider>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            <i className="fas fa-times mr-2"></i> Close
          </Button>
          <Button variant="success" onClick={handleSubmit}>
            <i className="fas fa-check mr-2"></i> Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showBonus}
        size="lg"
        dialogClassName="modal-70"
        onHide={handleCloseBonus}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail Discount </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* LEFT: Diskon */}
            <div className="col-md-6">
              <div className="card border-left-primary shadow h-100 mb-4">
                <div className="card-body">
                  <h5 className="card-title text-primary mb-3">
                    <i className="fas fa-percentage mr-2"></i>Product :{" "}
                    {dataBonus?.product_code +
                      "(" +
                      dataBonus?.product_name +
                      ")" ?? "-"}
                  </h5>
                  <ul className="list-unstyled mb-0">
                    <li className="d-flex justify-content-between">
                      <strong>Quantity:</strong>
                      <span className="text-end">
                        {dataBonus?.quantity ?? "-"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Unit Price:</strong>
                      <span className="text-end">
                        {dataBonus?.unit_price != null
                          ? formatCurrency(dataBonus.unit_price)
                          : "-"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Reg. Discount:</strong>
                      <span className="text-end">
                        {dataBonus?.reg_discount_percent != null
                          ? `${formatQuantityDecimal(
                              dataBonus.reg_discount_percent
                            )}%`
                          : "0%"}{" "}
                        (
                        {dataBonus?.reg_discount_amount != null
                          ? formatCurrency(dataBonus.reg_discount_amount)
                          : "-"}
                        )
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Special Discount:</strong>
                      <span className="text-end">
                        {dataBonus?.spec_discount_amount != null
                          ? formatCurrency(dataBonus.spec_discount_amount)
                          : "-"}
                      </span>
                    </li>

                    {Array.isArray(dataBonus?.special_discount_levels) &&
                    dataBonus.special_discount_levels.length > 0 ? (
                      dataBonus.special_discount_levels.map((item) => (
                        <li
                          key={item.level}
                          className="d-flex justify-content-between ps-3"
                        >
                          <span>
                            Level {item.level ?? "-"} ({item.percentage ?? 0}%)
                          </span>
                          <span className="text-end">
                            {item.applied_discount != null
                              ? formatCurrency(item.applied_discount)
                              : "-"}
                          </span>
                        </li>
                      ))
                    ) : (
                      <li className="d-flex justify-content-between ps-3 text-muted">
                        <span>No special discount levels</span>
                      </li>
                    )}

                    <li className="d-flex justify-content-between">
                      <strong>Total Discount:</strong>
                      <span className="badge badge-success text-end">
                        {dataBonus?.total_discount_amount != null
                          ? formatCurrency(dataBonus.total_discount_amount)
                          : "-"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Price After Discount:</strong>
                      <span className="text-end">
                        {dataBonus?.unit_price_after_discount != null
                          ? formatCurrency(dataBonus.unit_price_after_discount)
                          : "-"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Line Total:</strong>
                      <span className="text-danger font-weight-bold text-end">
                        {dataBonus?.line_total != null
                          ? formatCurrency(dataBonus.line_total)
                          : "-"}
                      </span>
                    </li>
                    <li className="d-flex justify-content-between">
                      <strong>Discount Type:</strong>
                      <span className="badge badge-info text-end">
                        {dataBonus?.special_discount_type ?? "-"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT: Bonus Item */}
            <div className="col-md-6">
              <div className="card border-left-success shadow h-100 mb-4">
                <div className="card-body">
                  <h5 className="card-title text-success mb-3">
                    <i className="fas fa-gift mr-2"></i>Bonus Item
                  </h5>
                  {dataBonus?.bonus_items?.length > 0 ? (
                    dataBonus.bonus_items.map((item, idx) => (
                      <div key={idx} className="mb-3 p-2 border rounded">
                        <div className="d-flex justify-content-between">
                          <div>
                            <strong>{item?.product_name ?? "-"}</strong> <br />
                            <small className="text-muted">
                              {item?.product_code ?? "-"}
                            </small>
                          </div>
                          <span className="badge badge-secondary">
                            {item?.uom_description ?? "-"}
                          </span>
                        </div>
                        <hr />
                        <p className="mb-1">
                          <strong>Bonus Qty:</strong>{" "}
                          {parseFloat(
                            item?.bonus_quantity ?? 0
                          ).toLocaleString()}
                        </p>
                        <p className="mb-1">
                          <strong>Applied Qty:</strong>{" "}
                          {item?.applied_bonus_quantity ?? "-"}
                        </p>
                        <p className="mb-0">
                          <strong>Multiples:</strong>{" "}
                          {item?.is_apply_multiples ? (
                            <span className="badge badge-success">Yes</span>
                          ) : (
                            <span className="badge badge-danger">No</span>
                          )}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">Tidak ada bonus item.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseBonus}>
            <i className="fas fa-times mr-2"></i> Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
